import api from '../utilities/api';

const canVote = (editionId, data) => {
  return api.post(`/bo/votes/edition/${editionId}/can-external-vote/`, {
    ...data
  });
};

const verified = (editionId, data) => {
  return api.post(`/bo/votes/edition/${editionId}/verified/`, {
    ...data
  });
};

const addVote = (editionId, data) => {
  return api.post(`/bo/votes/edition/${editionId}/external-vote/create/`, {
    ...data
  });
};

export { canVote, verified, addVote };
